import type { FieldErrors } from "@/types/AuthState";
import type { SetPasswordStage, ThunkRejectedPayload } from "@/store/thunks/thunkErrorTypes";
import { isAPIError, isFieldErrors } from '@/utils/type-guards';

export { isAPIError };

/**
 * Extracts error information from a thunk's rejected payload.
 * Handles all known payload shapes consistently.
 * Use this in every .addCase(thunk.rejected, ...) handler.
 */
export function extractThunkError(payload: unknown): {
  fieldErrors: FieldErrors;
  message: string | undefined;
  stage: SetPasswordStage | undefined;
  status: number | undefined;
} {
  if (
    payload !== null &&
    typeof payload === 'object'
  ) {
    const typed = payload as Partial<ThunkRejectedPayload>;
    return {
      fieldErrors: isFieldErrors(typed.fieldErrors) ? typed.fieldErrors : {},
      message: typeof typed.message === 'string' ? typed.message : undefined,
      stage: typed.stage === 'preCommit' || typed.stage === 'postCommit' ? typed.stage : undefined,
      status: typeof typed.status === 'number' ? typed.status : undefined,
    };
  }
  return { fieldErrors: {}, message: undefined, stage: undefined, status: undefined };
}
